import React from "react";
import { Routes, Route } from "react-router-dom";
import PrivateRoute from "../../../PrivateRoutes";
import EmployeeLayout from "../../EmployeeLayout/Pages/EmployeeLayout"
import PostJobForm from "../PostJob/Pages/PostJobForm";
import DraftJobTable from "../DraftJob/Pages/DraftJobTable";
import ViewJobDetails from "../DraftJob/Pages/ViewJobDetails";
import UpdatePostJobForm from "../DraftJob/Pages/UpdatePostJobForm";
import LiveJobs from "../LiveJob/Pages/LiveJobs";
import GetSendCandidatesforJob from "../SendCandidates/Pages/GetSendCandidatesforJob";
import SubmitCandidate from "../SendCandidates/Pages/SubmitCandidate";


const JobRoute = () => {
  return (
    <Routes>
        <Route path="Post-Job" element={<PostJobForm />} />
        <Route path="Draft-Jobs" element={<DraftJobTable />} />
        <Route path="View-Job-Details/:jobUID" element={<ViewJobDetails />} />
        <Route path="Update-Job/:jobUID" element={<UpdatePostJobForm />} />
        <Route path="Live-Jobs" element={<LiveJobs />} />
        <Route path="Sent-Candidates-For-Job/:jobUID" element={<GetSendCandidatesforJob />} />
         <Route path="Submit-Candidates/:jobUID" element={<SubmitCandidate />} />
    </Routes>
  );
};

export default JobRoute;
